define.alias("shared/helpers/word-initials", "settings/helpers/word-initials");